<!--
// app/components/pages/region-matches-match-homeTeam-vs-awayTeam/MatchEventsLogosVs.vue
-->
<script setup lang="ts">
import type { Team } from "#shared/team/domain/models/Team";
import { setAliasUrl } from "#shared/Shared/utils";

type Props = {
  awayTeam?: Team;
  homeTeam?: Team;
};

defineProps<Props>();
</script>

<template>
  <div class="events-teams">
    <div>
      <NuxtImg
        v-if="homeTeam?.logo.url"
        :src="setAliasUrl(homeTeam.logo?.url)"
        :alt="homeTeam?.name || ''"
        height="42"
        width="42"
        class="team-logo"
      />
    </div>
    <div>vs</div>
    <div>
      <NuxtImg
        v-if="awayTeam?.logo?.url"
        :src="setAliasUrl(awayTeam.logo.url)"
        :alt="awayTeam?.name || ''"
        height="42"
        width="42"
        class="team-logo"
      />
    </div>
  </div>
</template>

<style scoped>
.events-teams {
  @apply flex md:flex-col items-center gap-2 md:gap-1 max-w-[130px] md:max-w-[40px];
}

.team-logo {
  @apply w-11 h-11 max-w-11 max-h-11 object-contain object-center;
}
</style>
